/*
  Shreya — <shop-the-look>
  Hotspot dots open a small product card; the optional list beside the image
  lights up the matching dot (and vice versa).
*/
(() => {
  if (customElements.get('shop-the-look')) return;

  class ShopTheLook extends HTMLElement {
    connectedCallback() {
      this.spots = Array.from(this.querySelectorAll('[data-spot]'));
      this.rows = Array.from(this.querySelectorAll('[data-spot-row]'));

      this.spots.forEach((spot) => {
        const toggle = spot.querySelector('[data-spot-toggle]');
        const close = spot.querySelector('[data-spot-close]');
        if (toggle) toggle.addEventListener('click', () => (this.openSpot === spot ? this.closeAll(true) : this.open(spot)));
        if (close) close.addEventListener('click', () => this.closeAll(true));
        spot.addEventListener('mouseenter', () => this.highlight(spot.dataset.spot, true));
        spot.addEventListener('mouseleave', () => this.highlight(spot.dataset.spot, false));
      });

      this.rows.forEach((row) => {
        const id = row.dataset.spotRow;
        row.addEventListener('mouseenter', () => this.highlight(id, true));
        row.addEventListener('mouseleave', () => this.highlight(id, false));
        row.addEventListener('focusin', () => this.highlight(id, true));
        row.addEventListener('focusout', () => this.highlight(id, false));
      });

      this.onDocClick = (event) => {
        if (this.openSpot && !this.openSpot.contains(event.target)) this.closeAll(false);
      };
      this.onKey = (event) => {
        if (event.key === 'Escape' && this.openSpot) this.closeAll(true);
      };
      document.addEventListener('click', this.onDocClick);
      this.addEventListener('keydown', this.onKey);

      // theme editor: selecting a hotspot block opens its card
      this.onSelect = (event) => {
        const spot = event.target.closest && event.target.closest('[data-spot]');
        if (spot && this.contains(spot)) this.open(spot);
      };
      this.onDeselect = () => this.closeAll(false);
      document.addEventListener('shopify:block:select', this.onSelect);
      document.addEventListener('shopify:block:deselect', this.onDeselect);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('shopify:block:select', this.onSelect);
      document.removeEventListener('shopify:block:deselect', this.onDeselect);
    }

    open(spot) {
      this.closeAll(false);
      const card = spot.querySelector('[data-spot-card]');
      const toggle = spot.querySelector('[data-spot-toggle]');
      if (!card) return;
      card.hidden = false;
      spot.classList.add('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      this.openSpot = spot;
      this.classList.add('has-open-spot');
      this.highlight(spot.dataset.spot, true, true);
      // move focus into the card for keyboard users only
      if (toggle && toggle.matches(':focus-visible')) {
        const first = card.querySelector('a[href]:not([tabindex="-1"]), button:not([disabled])');
        if (first) first.focus({ preventScroll: true });
      }
    }

    closeAll(returnFocus) {
      const spot = this.openSpot;
      if (!spot) return;
      const card = spot.querySelector('[data-spot-card]');
      const toggle = spot.querySelector('[data-spot-toggle]');
      if (card) card.hidden = true;
      spot.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      this.classList.remove('has-open-spot');
      this.highlight(spot.dataset.spot, false, true);
      this.openSpot = null;
      if (returnFocus && toggle) toggle.focus({ preventScroll: true });
    }

    highlight(id, on, sticky) {
      if (!on && !sticky && this.openSpot && this.openSpot.dataset.spot === id) return;
      this.spots.forEach((spot) => {
        if (spot.dataset.spot === id) spot.classList.toggle('is-highlighted', on);
      });
      this.rows.forEach((row) => {
        if (row.dataset.spotRow === id) row.classList.toggle('is-highlighted', on);
      });
    }
  }

  customElements.define('shop-the-look', ShopTheLook);
})();
